
import { Component, Prop, Vue } from 'vue-property-decorator';
import { isArray } from 'lodash';

export type InformationBlock = {
  label: string;
  key: string;
  value?: any;
  cols?: number;
  labelClass?: string;
  valueClass?: string;
  colClass?: string;
};

@Component
export default class InfoBlock extends Vue {
  @Prop({ required: true }) info!: InformationBlock[];

  @Prop({ required: false }) model?: any;

  @Prop({ default: '' }) emptyValue!: string;

  isArray(value?: any) {
    if (value) return isArray(value);
  }
}
